export default {
  login: {
    title: "Войдите в аккаунт",
    footer: "Аккаунт создаёт ваш менеджер и выдаёт логин и пароль. Забыли пароль? Обратитесь к менеджеру.",
    username: "Логин",
    usernamePlaceholder: "imya.familiya",
    password: "Пароль",
    submit: "Войти",
    failed: "Не удалось войти. Попробуйте ещё раз.",
  },
  twofaSetup: {
    title: "Настройте двухфакторную аутентификацию",
    subtitle: "Для вашей роли 2FA обязательна. Это займёт минуту: отсканируйте код приложением-аутентификатором.",
    continue: "Перейти в платформу",
    signOut: "Выйти",
    failed: "Не удалось начать настройку.",
  },
  twofa: {
    title: "Двухфакторная аутентификация",
    subtitle: "Введите 6-значный код из приложения-аутентификатора.",
    subtitleBackup: "Введите один из резервных кодов.",
    verify: "Проверить",
    useAuthenticator: "Использовать код из приложения",
    useBackup: "Использовать резервный код",
    backToSignIn: "Назад ко входу",
    lostPhone: "Потеряли телефон? Используйте резервный код или попросите владельца сбросить 2FA.",
    failed: "Проверка не пройдена.",
    digit: "Цифра {{n}}",
  },
  setPassword: {
    title: "Задайте свой пароль",
    subtitle: "Вы вошли с временным паролем. Чтобы продолжить, придумайте собственный.",
    newPassword: "Новый пароль",
    confirm: "Подтвердите новый пароль",
    ruleLength: "Не менее 10 символов",
    ruleMatch: "Пароли совпадают",
    ruleDifferent: "Не совпадает с временным паролем",
    save: "Сохранить и продолжить",
    failed: "Не удалось установить пароль.",
  },
};
